import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const api = axios.create({
  baseURL: backendUrl + "/api",
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== "/login") {
      try { sessionStorage.setItem("session_notice", typeof error.response?.data?.detail === "string" ? error.response.data.detail : "Oturumunuz sona erdi. Yeniden giriş yapın."); } catch {}
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const formatApiError = (error) => {
  const detail = error.response?.data?.detail;
  if (!detail) return error.message || "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return detail.message || String(detail);
};

export default api;
